import "core-js/modules/es6.regexp.search";
import { __assign, __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import ClientServices from '@/modules/clients/ClientServices';
var client = {
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  addresses: [],
  addresses_to_delete: [],
  dni_cif: ''
};

var ClientModel =
/** @class */
function (_super) {
  __extends(ClientModel, _super);

  function ClientModel() {
    var _this = _super.call(this, client, ClientServices) || this;

    _this.modelName = 'Cliente';
    _this.request = 'JSON';
    return _this;
  }

  ClientModel.prototype.searchBy = function (query) {
    return __awaiter(this, void 0, void 0, function () {
      var request;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.search(__assign({}, query))];

          case 1:
            request = _a.sent();

            if (request.complete) {
              return [2
              /*return*/
              , this.handleSuccess({
                data: request.data.results,
                total: request.data.total
              }, request.message, null)];
            } else {
              this.handleError(request, null);
              return [2
              /*return*/
              , {
                data: [],
                total: 0
              }];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ClientModel.prototype.getClientFile = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.downloadClientFile({
              method: 'GET',
              headers: {
                Accept: '*/*'
              },
              responseType: 'blob'
            })];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  };

  ClientModel.prototype.getClientsListByLocal = function (protocol) {
    return __awaiter(this, void 0, Promise, function () {
      var response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.getClientsListByLocal(__assign({
              method: 'GET'
            }, protocol))];

          case 1:
            response = _a.sent();

            if (response && response.data) {
              return [2
              /*return*/
              , {
                data: response.data.results,
                total: response.data.total
              }];
            }

            return [2
            /*return*/
            , {
              data: [],
              total: 0
            }];
        }
      });
    });
  };

  return ClientModel;
}(BaseModel);

export default ClientModel;